import React from "react";
import { IdentifierField } from "../../../../common/components/IdentifierField";

/**
 * Componente custom para el campo AuthorComposer.ipi. Al salir del campo guarda el IPI
 * con sus 11 dígitos (completa con ceros a la izquierda el número de SADAIC o el CAE)
 * y muestra el error de la regla; el detalle está en IdentifierField, común a los
 * cuatro campos de identificadores.
 *
 * Llená/editá este archivo en `develop`. El generador lo emite como stub estable en
 * `base` (merge-safe). Recibe los mismos props que un control estándar del form.
 */
export interface AuthorComposerIpiCustomFieldProps {
  value: any;
  onChange: (value: any) => void;
  error?: boolean;
  helperText?: string;
  label?: string;
  description?: string;
}

export const AuthorComposerIpiCustomField: React.FC<AuthorComposerIpiCustomFieldProps> = (
  props
) => <IdentifierField kind="ipi" optional {...props} />;
